"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
var _index = _interopRequireDefault(require("@/components/Tinymce/index"));
var _PrizeItem = _interopRequireDefault(require("../components/PrizeItem"));
var _drawLottery = require("@/api/drawLottery");
var _permission = require("@/utils/permission");
var _enums = require("../enums");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var operateMaps = {
  add: '新增活动',
  edit: '编辑活动',
  copy: '复制活动',
  detail: '活动详情'
};
var _default = exports.default = {
  name: 'DrawActivityAdd',
  components: {
    Tinymce: _index.default,
    PrizeItem: _PrizeItem.default
  },
  data: function data() {
    var _this2 = this;
    var disabledDate = function disabledDate(time) {
      if (_this2.detail.drawStartTime) {
        return time.getTime() < new Date(_this2.detail.drawStartTime).getTime();
      }
      return time.getTime() < Date.now() - 8.64e7;
    };
    return {
      tempRoute: {},
      operate: 'add',
      operateMaps: operateMaps,
      id: '',
      grid: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24
      },
      headTab: [{
        tit: '基础设置',
        name: '1'
      }, {
        tit: '抽奖设置',
        name: '2'
      }, {
        tit: '奖项设置',
        name: '3'
      }],
      currentTab: '1',
      styleOptions: _enums.styleOptions,
      joinTypeOptions: [{
        label: '不限',
        value: 1
      }
      // { label: '消耗积分', value: 2 },
      ],
      pickerOptions: {
        // 时间有效校验
        disabledDate: disabledDate
      },
      prizeIndex: '0',
      loading: false,
      detail: {
        // drawStartTime: '2025-03-20 00:00:00'
      },
      formValidate: JSON.parse(JSON.stringify(_enums.defaultFormData)),
      ruleValidate: _enums.formRules,
      loadingBtn: false,
      prizeTab: '0'
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['mediaDomain'])), {}, {
    isDisabled: function isDisabled() {
      return this.operate === 'detail';
    },
    isEdit: function isEdit() {
      return this.operate === 'edit';
    },
    isCopy: function isCopy() {
      return this.operate === 'copy';
    },
    maxPrizeLength: function maxPrizeLength() {
      var activityStyle = this.formValidate.activityStyle;
      if (activityStyle === 1) {
        // 转盘抽奖
        return 12;
      } else if (activityStyle === 4) {
        // 九宫格抽奖
        return 8;
      }
      return 12;
    },
    prizeRemovable: function prizeRemovable() {
      return this.formValidate.activityStyle !== 4;
    },
    prizeWinProbabilityTotal: function prizeWinProbabilityTotal() {
      var prizeSaveRequest = this.formValidate.prizeSaveRequest;
      var idx = prizeSaveRequest.findIndex(function (item) {
        return item.prizeType === 99;
      });
      var total = 0;
      prizeSaveRequest.forEach(function (item, index) {
        if (index !== idx) {
          total += (item.winProbability || 0) * 100;
        }
      });
      return total / 100;
    }
  }),
  created: function created() {
    this.tempRoute = Object.assign({}, this.$route);
    this.operate = this.$route.params.operate;
    this.id = this.$route.params.id;
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (this.mediaDomain) {
              _context.n = 1;
              break;
            }
            _context.n = 1;
            return this.$store.dispatch('settings/getMediaDomain');
          case 1:
            if (this.id && this.id !== '0') {
              this.getActivityInfo(this.id);
            } else {
              this.initActivity();
            }
          case 2:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: {
    checkPermi: _permission.checkPermi,
    getActivityInfo: function getActivityInfo(id) {
      var _this3 = this;
      this.loading = true;
      (0, _drawLottery.activityDetailApi)(id).then(function (data) {
        _this3.initData(data);
        _this3.loading = false;
      }).catch(function (res) {
        _this3.loading = false;
      });
    },
    initData: function initData(data) {
      data.drawTime = [data.drawStartTime, data.drawEndTime];
      data.prizeSaveRequest = data.prizes || [];
      this.detail = data;
      for (var key in data) {
        if (this.formValidate.hasOwnProperty(key)) {
          this.formValidate[key] = data[key];
        }
      }
    },
    changeStyle: function changeStyle() {
      var _this$formValidate = this.formValidate,
        activityStyle = _this$formValidate.activityStyle,
        prizeSaveRequest = _this$formValidate.prizeSaveRequest;
      var formData = _enums.defaultFormDataMap[activityStyle] || {};
      for (var formDataKey in formData) {
        var val = formData[formDataKey];
        if (formDataKey === 'activityBackPic') {
          val = this.mediaDomain + val;
        }
        this.formValidate[formDataKey] = val;
      }
      if (activityStyle === 4) {
        if (prizeSaveRequest.length !== 8) {
          this.initStyle4Prizes();
          this.prizeTab = '0';
        }
      }
    },
    initActivity: function initActivity() {
      var _this$formValidate2 = this.formValidate,
        activityStyle = _this$formValidate2.activityStyle,
        activityBackPic = _this$formValidate2.activityBackPic;
      this.formValidate.activityBackPic = this.mediaDomain + activityBackPic;
      if (activityStyle === 1) {
        // 转盘抽奖
        this.initStyle1Prizes();
      } else if (activityStyle === 4) {
        // 九宫格抽奖
        this.initStyle4Prizes();
      }
    },
    initStyle1Prizes: function initStyle1Prizes() {
      this.formValidate.prizeSaveRequest = [_objectSpread(_objectSpread({}, JSON.parse(JSON.stringify(_enums.prizeItem))), {}, {
        prizePic: this.mediaDomain + _enums.prizeItemPicMap[0]
      }), _objectSpread(_objectSpread({}, JSON.parse(JSON.stringify(_enums.prizeItem))), {}, {
        awardName: '谢谢参与',
        prizeName: '谢谢参与',
        prizeType: 99,
        redemptionRule: '',
        prizePic: this.mediaDomain + _enums.prizeItemPicMap[99]
      })];
    },
    initStyle4Prizes: function initStyle4Prizes() {
      var list = [];
      for (var i = 0; i < 8; i++) {
        var prize = JSON.parse(JSON.stringify(_enums.prizeItem));
        prize.prizePic = this.mediaDomain + _enums.prizeItemPicMap[0];
        if (i === 7) {
          prize = _objectSpread(_objectSpread({}, prize), {}, {
            awardName: '谢谢参与',
            prizeName: '谢谢参与',
            prizeType: 99,
            redemptionRule: '',
            prizePic: this.mediaDomain + _enums.prizeItemPicMap[99]
          });
        }
        list.push(prize);
      }
      this.formValidate.prizeSaveRequest = list;
    },
    removePrizeItem: function removePrizeItem(targetName) {
      var index = +targetName;
      if (this.prizeTab >= index) {
        this.prizeTab = '' + (+this.prizeTab - 1);
      }
      this.formValidate.prizeSaveRequest.splice(index, 1);
    },
    addPrizeItem: function addPrizeItem() {
      var prizeSaveRequest = this.formValidate.prizeSaveRequest;
      if (prizeSaveRequest.length >= this.maxPrizeLength) {
        return;
      }
      // 寻找谢谢参与的奖项下标
      var index = prizeSaveRequest.findIndex(function (item) {
        return item.prizeType === 99;
      });
      var prize = JSON.parse(JSON.stringify(_enums.prizeItem));
      prize.prizePic = this.mediaDomain + _enums.prizeItemPicMap[0];
      if (index === -1) {
        prizeSaveRequest.push(prize);
      } else {
        prizeSaveRequest.splice(index, 0, prize);
      }
    },
    modalPicTap: function modalPicTap() {
      var _this = this;
      if (_this.isDisabled) return;
      this.$modalUpload(function (img) {
        if (!img) return;
        _this.formValidate.activityBackPic = img[0].sattDir;
      }, false, 'content');
    },
    // 上一步
    handleSubmitUp: function handleSubmitUp() {
      this.currentTab = (Number(this.currentTab) - 1).toString();
    },
    // 下一步
    handleSubmitNest: function handleSubmitNest(name) {
      var _this4 = this;
      if (this.isDisabled) {
        this.currentTab = (Number(this.currentTab) + 1).toString();
        return;
      }
      this.$refs[name].validate(function (valid, obj) {
        if (valid) {
          _this4.currentTab = (Number(_this4.currentTab) + 1).toString();
        } else {
          for (var key in obj) {
            var msg = obj[key][0].message;
            return _this4.$message.warning(msg);
          }
        }
      });
    },
    //保存接口数据更新
    getFormData: function getFormData() {
      var data = _objectSpread(_objectSpread({}, this.formValidate), {}, {
        drawStartTime: this.formValidate.drawTime[0],
        drawEndTime: this.formValidate.drawTime[1]
      });
      if (!data.prizeSaveRequest.length) {
        this.$message.warning('请添加奖项');
        return false;
      } else {
        var activityStyle = data.activityStyle;
        if (activityStyle === 1) {
          // 转盘抽奖，如果奖项数量小于2个，提示
          if (data.prizeSaveRequest.length < 2) {
            this.$message.warning('转盘抽奖奖项至少需要2个');
            return false;
          }
        } else if (activityStyle === 4) {
          // 九宫格抽奖，如果奖项数量不为8个，提示
          if (data.prizeSaveRequest.length !== 8) {
            this.$message.warning('九宫格抽奖奖项需设置8个');
            return false;
          }
        }
        for (var i = 0; i < data.prizeSaveRequest.length; i++) {
          var item = data.prizeSaveRequest[i];
          if (item.prizeType !== 99) {
            if (!item.awardName || !item.prizeName || !item.prizePic || !item.ruleDes || !item.winProbability && item.winProbability !== 0 || item.prizeType === 1 && !item.pointsValue || item.prizeType === 2 && !item.prizeNum || item.prizeType === 2 && !item.price || item.prizeType === 2 && !item.validityDate) {
              this.$message.warning('请填写奖项信息');
              return false;
            }
          }
          item.sort = i;
        }
      }
      if (this.operate === 'edit') {
        data.activityId = this.id;
      }
      return data;
    },
    // 保存
    handleSubmit: function handleSubmit(name) {
      var _this5 = this;
      this.$refs[name].validate(function (valid, obj) {
        if (valid) {
          _this5.postData();
        } else {
          for (var key in obj) {
            var msg = obj[key][0].message;
            return _this5.$message.warning(msg);
          }
        }
      });
    },
    // 新增保存数据
    postData: function postData() {
      var _this6 = this;
      this.loadingBtn = true;
      var data = this.getFormData();
      if (!data) {
        this.loadingBtn = false;
        return;
      }
      var func = this.operate === 'edit' ? _drawLottery.activityUpdateApi : _drawLottery.activityCreateApi;
      func(data).then(function (res) {
        _this6.$message.success('保存成功');
        setTimeout(function () {
          _this6.$router.push({
            path: '/marketing/draw/activity'
          });
        }, 500);
        _this6.closeSelectedTag();
        _this6.loadingBtn = false;
      }).catch(function (res) {
        _this6.loadingBtn = false;
      });
    },
    isActive: function isActive(route) {
      return route.path === this.$route.path;
    },
    closeSelectedTag: function closeSelectedTag() {
      var that = this;
      that.$store.dispatch('tagsView/delView', that.$route).then(function (_ref) {
        var visitedViews = _ref.visitedViews;
        if (that.isActive(that.$route)) {
          that.toLastView(visitedViews, that.$route);
        }
      });
    },
    toLastView: function toLastView(visitedViews, view) {
      var latestView = visitedViews.slice(-1)[0];
      if (latestView) {
        this.$router.push(latestView.fullPath);
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === 'Dashboard') {
          // to reload home page
          this.$router.replace({
            path: '/redirect' + view.fullPath
          });
        } else {
          this.$router.push('/');
        }
      }
    }
  }
};